import * as React from 'react';
import styles from './ExternalLink.module.scss';
import classNames from 'classnames';
import isNil from 'lodash-es/isNil';

export interface ExternalLinkProps {
	href: string;
	text?: string;
	className?: string;
	type?: 'tel' | 'mailto';
}

export const ExternalLink: React.FC<ExternalLinkProps> = props => {
	const { text, href = '', className, type } = props;
	let ownHref = href;
	if (type) {
		ownHref = `${type}:${href}`;
	}
	return (
		<a href={ownHref} className={classNames(styles.externalLink, className)}>
			{isNil(text) ? href : text}
		</a>
	);
};

export default ExternalLink;
